module.exports = __webpack_public_path__ + "static/media/dealer-bombay 1.0b080139.png";